import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { INotificationLogModel } from '@apps-common/types/portal/notification'

const getNotifications = async (skip: number, take: number): Promise<INotificationLogModel[]> =>
  axios.get(`/my-monitoring/sites/GetSiteNotifications?skip=${skip}&take=${take}`).then((res) => res.data?.data)

type Props = { take: number }

export const useMyMonitoringGetNotifications = ({ take }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage } = useInfiniteQuery({
    ...{ cacheTime: 0 },
    queryKey: ['getMyMonitoringNotifications', take],
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) => getNotifications(pageParam, take),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < take) {
        return null
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: ['getMyMonitoringNotifications'] })
    },
    []
  )

  return { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage }
}
